import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getRecommendedComics } from '@/mocks/comics';

export default function RecommendedSection() {
  const recommended = getRecommendedComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">编辑推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分热门漫画，不容错过</p>
          </div>
          <Link
            to="/category/hanman"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {recommended.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="large" />
          ))}
        </div>
      </div>
    </section>
  );
}